import TypeScriptImg from '../images/Typescript.svg.png'
import rmit from '../images/rmit.jpg'
import chatbot from '../images/chatbot.png'
import mesclone from '../images/messenger-clone.png'
import pwLogo from '../images/PW-logo.png'
import qwirkle from '../images/qwirkle.jpeg'
import retroAI from '../images/retroAI+.png'
import shineSols from '../images/shine_solutions_logo.jpeg'
import socialMedia from '../images/social-media-app.png'
import uniware from '../images/uniware-logo.png'
import bookeroo from '../images/bookeroo.png'
import ahLogo from '../images/ahLogo.png'
import job from '../images/jobpilot.svg'
import brain from '../images/brain.svg'
import devopslive from '../images/devopslive.svg'
import mail from '../images/mail.svg'
import rr from '../images/reelresume.svg'

export const Bio = {
  name: "Hibbaan Nawaz",
  roles: [
    "Full Stack Developer",
    "Software Engineer",
    "Software Developer",
    "Back-End Developer",
    "Front End Developer"
    

  ],
  description: "I am a passionate software developer with a deep enthusiasm for technology and a strong focus on machine learning. My curiosity and dedication drive me to explore cutting-edge developments in the field, making me an invaluable contributor to the ever-evolving world of software and artificial intelligence.",
  github: "https://github.com/s3847243",
  resume:
    "https://drive.google.com/file/d/1rAcDVCMidMYYXyO-DngDzlvAxXNVKRUT/view",
  linkedin: "https://www.linkedin.com/in/hibbaan-nawaz/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "TailwindCSS",
        image:
          "https://cdn.simpleicons.org/tailwindcss/06B6D4",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "TypeScript",
        image:TypeScriptImg,
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEWCgoL////l5eXk5OTm5ubu7u74+Pj19fXx8fH7+/vr6+t+fn52dnZ7e3t8fHzz8/OGhoaTk5Pa2tq3t7e7u7utra3Q0NCZmZnFxcWkpKSMjIzKysqpqanX19e/v7+dnZ1ra2tH/Sn9AAASPElEQVR4nOVdbZuyKhBWwTcErcxqa7fO//+VB9RKGF6tdvWc+bLPNY+m48DMzc0AURzHWYKTjP9FOEn5nzTBaKJNPLW5UYtxQozawqYtH1o8V4ui/4eFKEG9hcn4fgmaqU2S0ZaHNndpi0Fbjlr8Ni0atVGWZXmapjn/y/8U/E/B//6etnmnttFoI/4BemcgxUVBWuLS8iaES/6XENLwPw1vSpPPngzXPj67TYtDtIhrI6ztZm/pkuKZDbcpLgt0uV73+7b74tJ1bdterztUZDgl5Se6JJpoP+ZD/uNNnKNTdztHlFJWV7LUjCuj8609oIx/hfRzPvxI3yqanBzaIzeNGxbZpKq4pdG2PeBcdKKXepyhH747lgotut4iyuymKYYyGt1O6aRpvi+WvrXzYZKSXbehDscZrKxp1F1wms7sfNZ8iAa/oLGbIeSjJRrt9RjmO+hLtj31HkDD+6GhS6Kxm3losaKNAs0yG9uQ042+Yt1dano8lS+ahT6QLUjH2BvMG42sOxKTt2WLV8MLwqT42b7FfU+p6PYkUunrQSd6PUU0pK3e576nsKgl8euJQ84W4ck/IWj/UmyxScW+EQlO/gi9M1vkqPuYfYONXfGWbDHbh+1H7Rts3AdCNUX7Qj/M8lNUf9g+IXV0KssX+uH8WIo2n4gvOmFnFAjVprF0bj7Mvukv2SeEfudkbj6cBdUScnhz/nMJ745kHoCbh0uz2286cBB2K3NvqDbFpeHZAse/7cBBKnpKfZvmS1wbSY6/78BB2FGid/wAXPAYvznMGvy9R6rqEH+Ya0ua6185cBDaEm1eQO/i2vDxt3KgSdgRuUmA2Vwb2W3+roXepdqgIAAX0g/zw187cBB2yD/DtaXt33bBp/DO6IBqs0ZP6dcyPCiEfZXeAM4b0xTH3xhH+Aq72aHaFNP4RRqcnP8+xkylOqO3ZguMFhBEZRlCqgmqhXJtJdr8tUE6yd/GtZVkaQ4cJS0n75tqE0fqw7VhtFADo2j3Fq4NL7OJ9rJ5C9eWLNdAHlHdAM7ZD/OFpQlZqm2hQrU8kGtLj0s2kJt4dAE4Rz5Mv5aEZHRS6wCcP9eWt8vBoiahJzuAs0YacljKaMIm9IKtkcaWLXbL96AQtsMWAGcZHyZ4wXlCkk0410Z6Vm3hYfQp1TZWoJoX19Zc19FGhbCOhI+e8M8aosxd6CGYa8PJX790mFTBXFu8mk44SHUsIdeW27i2VWTCqdALCeHakmxtBnITrflQ5drIbV1ttJctCeDaVtdGhdCDPtLossUK26gQmjW+XNv3Ctsol+o7s3NtZEwcGVqnC7kTf0YriJ1ry9cCuKGc/bi203rwqCrs4sW1/fVrviKVB9fWtEtnZmxSt42La0vQetuoELZzcW2kW2emuEvVObm2dbtQpH0719bs1+1CkfaJbWyBydpdyIONNVuQdu0u5E5sCeTaSErEGJ+kxfoN5CYWI9c2ADh59PQT3EjF4roqOh+3x/OG/5u5y/oAJvT9qup1GwO6ZD+xmWvbej5sfCSj5/ZARAMfJCM/+1tlLz5lRawI8QP61Zd649Fw5TZOTFyb57PGV2VfP6X6UCGojay/A27wI2Yr9TbjrBFFyXQEnOcj15ZnTUC2p+eDzrpRdluzjdAX8dbjuTRRbjLzuVVX5gPXlitcm3+qoEdksa935Nn4Y/SiXty42w5rlXtyy8uy2JAPfYdNbLNz2CfkZHxtmqrXXpxPPqu32PzODgau7eZnIL162Ce+4tk0StmAa13tlKrxyTp1W91kru1BknrFmaqv8PCTzvCL9bd6pYP7omqn3zmuR4lubHH1iTMUxgmLXAwvAt7YEjciTXDKHK262uPHngVPH6am9CK92j7EQPO3Zo16pY2DBoni7HrPSYUGH+OTYYzvkwxhGJxrIogcpZlaoGrgdtdPUJJDrs1j0h42LrcYmh+I/uauBS51dML+nl0Os4U73fd1HUDK5HDat/vrAWW6/zZlDQoyjomHVt1ty4R3qbocjp6cLCnr4Ovj9nzf1YND8HOrAg8hX/o3ZwDy6R8LEoUPAoo2mcy1cZDjJLqrLXj3n7OCsistmNN/O/h72lcAXd+viIlibpTEtRVO+oKpjRCddW+kATzY0BUBcuhgtBHJWxKPTtj/uPgwUj5sDG3pIaDfGFdfwJRpYA5AjNRkgUppy65M+LhPgAqJa8t97phIaUbWfKiqAk/TtaqFIGOBj+DVCe+/PeXasCsbKnGhtI/M1RczLCcCTTDeyxeCRLH3H/7s5P3asGNJk9pnXNQDxfL1hkANEYTcTtVE4dkJhdQnOVs4SbbQtkJlWGYigKgK49OpDWqi8O2EQqqWTLk20thBKZNzgE/AVj6/6TIwkJoMUoGH/Tshl2Mjc232q2Xo6zXMUrrQyQA71Qg2YcNALw0s55W5Nvv4rJZ7oRPZ9yI3sdKYW1SIkN+vVEFPQCfsfziXuDY7oqH59EmepSiKC4zVDwCVjYNKNR6XgVwuv//OteV52pgake5d/VyoRhHz0AUMpPqSOpAoQgvt6lPT2zbEUvusIZPgjHdjUbqY0UKA6HtvqXYH19RX3VAbPeRDYiWhqPQoF7ybvLrnffRHsYb3AzWNzKiAuZGnhYjYWp7Ckvh/Sya9uYUxrKV+Lr6GmihCO6GQ82jhEEttV9bSwDcgolVS80vNN4KBVKkmiqBMeJfp2MIYy4XIDSZkklhOo5YLmYPg8oej0x8tJ1xbYbNQ7k4hdZkydLPdCQdSU5lXhkaLwYeEkKK0/sRRelpISZgchK3eB4ThRLJ5FT4MpYSk5RBLbfMGlZyYgibgpHhhnX6t5O8oycyS8/7pYyzFV8tXklF3wzb+EkndyxJqxGO0RJ6Ques+6v3UQttEjmsizVcsnK8QMJAaZXYtaHWNH1xbaesicC5srji6MJyR6r/L7OKJ6ppz2/IhllotfJeBrioBzeRwPLsTit/bk2c+tI3w32ehk87TcK0vLL7iFj65Nhvwrt9mobMcSdMVZ9snIBV5cG3E9nX13WOOOOGQpp3aA7D718ZY+ksWWgeh/TvpbpptYj+svVtoA1RggDpbXPUIeug2O9TcLRR8VGHz4fv6ocNCOKXYiyONWiz8ikWx3sDT2CIN0z53loX2dzU1lrkp/x5p+mxhs1DOFqL8dqZgeywFjNRDunkZo+rSJ9dmzYfSAJz8Q2eL3UDLDLov96VYyDP+nWtrbBYyaQrihehtfx0wSfPyQ6s2e3Bt1vYjD/I+ZqHFQHNdjv0nReTyGVvINI2V75gvgP5VTJyz4vM+thgstI2AZTrzIxaqiaJQYcacEUY9+rCPpdZamvkshreoiWILaq9mpAy2688eGCy03i8nRJ/asFBRh6AnBkF4+D4yFBFPrk1OVB9YNaTSv31BLcj/wSmDNhOuzTq55k1dzxSQKHpbAIXqUUgsC82eXBvC1jeQwkBQtbuXqIliDHugnQanjOnMTGptAnKDmWuISdRCnUfGBe00MGWcpZkZ+9yTVA0V0hHZVAyXqCOKs/F/Aj/ubfRhURRNXlpBsdwRDTVc2hsvu4noiSjVU5MpCrVkJSxlVG3JbbtzbaaSnvFamVzwX1gj5xntJWqikLu56sSQGRp2kOra7F9HflP/SWDpy2hDFFMLSqSAUIN6z4BlS2Ief1LXZq/FkJup92PkGKJjaUCiUJwEeI2AlMGjx7OuLcHEfrUM3HzHFzK41IEhlSGBfVx1YsCeJESU85bJ3UI7GFN6ix//JY9pdRVboKITJK0KtFPvMoIjCalrUx/ks5uiMl+mwUKgm2mwJ+TfPA2c1rWVOQc3jtpEqtQS+MyrO9wDE4U+D6kW+i3t4TFMrCEts0ddmyPLgfIz5wkClVw0rQnAYFJLOzCD8dQvZYgZdmkNqatGGGRf05qm0b6NUhUO469viTpsp36xPFbWkDYu0AdQ4o/lMCtQ6g1dCBKFOSWrT8492ulQ5/3g2ji4yVyTCrCyPm4N/CCLADMIG6Baom4mD2A79UgZ9bXhiE3Y9lhR4kxymqmvvGPAkRWN4Iw83C8Flv5b1j2B9Q3ulEF3GKwKchMwunXNh+/oeRJuzejmW7O+FDZA4BcrbAT+dqeMTQbXkDpHRZpFM4Mnd5e9OMq42192aoFaLw0MIaBX258M5hVdA5yqfZwNxWMp7tcfYjc9UQetrnwKbB2gxTs+L2ynjtlvdhlOXcaTNaQYu9MMm2Ui3BAcLIJzDvzgMjA75mDJzDWkzDa7oJccLs2AcxTOB8Nb7CsTpmtIB66tLEjqnITmUp/1iwyNomsZteoQD2IEVNlaU0Z9SnNu1IRrG3Yc8Bsx+KzFf4huFAJ+wWtIDdvptyW/GHYc8FuPT8EKCaPkuhPaYAL3eqxm+s2Y3/r1+LodeDz3VKgA9WCQkxbzgEThSd7BdmpMGYKTePqw59rynGOcwrsmgG08ljxfIu0HA4nCm/aB7dSUMmg+GDXl2ob92vypUFZdtcn9LunecAgySBT+82bem6KIzbAM+7WFMPbifHBDvSQ+Gc+whoWyATuJwnaqJ9Aowsb92sL2GKppddwfyMSZOTmITYYsrV19x6DFTGApcqzdXm4bg/3a7uePkfBtL8UidVZtztvteRP1/7b65HzcyhL2tI1y91aHUtipX7rN/RhPuLZxvzYHqbgS+d/t11aWgmsjOf/L/6Tr33OPCahWlg23JisnXNu42/VaN0l+ipjPtZ6N8B/Z+9JyNgJZuRN7jk3esXzk2sY/Ta6hHNYkrCgGa5pC5dri+9kItvUzi5f66nM2wpqbaeV1NsLa9/NWz0Z4cG09yBFbZJTzClaXIBsyQjWMn7EUno1gX424ZKE/WDkbQbPbNcK8wfov116UiLMR7hYihWsry4L/fQA4n920Figsf0C1Jwwt5WwxJn+yosOsnsLGrQS9ziFNV3nOTBpyDumHyrk/KfTR+RQfTri2CYDLV5cU2amUrNBzbRN3ktWd2dXEmlPJrOeQ/vU7B0oSfA4pXtWZT/ez80znkHJbe65NAnAzquP/TEQZhQTVjFybfJjHarpiP/8uQTWQLTDSWJgs+bxqSTYAqk0tlLk2CcClazlLFqUqVDNzbUryX0W0EdMZKlTzOYc0WdWZzrZTq60+TMnX0k1kw7ncifkcUhnkKACuycuFY/DqFuugmpVrUwEcLIdZkFRnPVTzPZd7mHNbcs7YTDpfEnIOqQzg/toMi5igmoVrGwGcpHXVD/+dZCXWQjVs59pgg13qIUm5Eaq5uDbVwnKJDbXiBhqhmotrgwAOb5bmxuqMSzNUc3FtcvIf4s/CkoZIExaoFpYtBm0xa3PGT0l9hHnBmi2sPrwDuNtyABy7OaCamWtrLAAu3i9lpEH3LqjmwbWNWtmd12WYKBbFOaCaF9em0ZKfJfTFeufufD5cm1aLkfGUqt8Sdu7fzAHVDFybB4CLy++/bam0Hd5MhmpYhWoTrSVbID0D9/5tIwKk3yzHA6r5cW0GLbEci/dhYVuEVVCmh2qeXJsEiCba8o/SBt0X/Ttk2jcL5dqQTUt2f+BGdu6PzEy8oJo316YHcFxL9HX4n5OKtinW5AWPbGHn2sza/PabTZXeUqIHZU5tZIRqDm2TGZYbfEBYdMkAiNRDS6jVcW2q4wzaIr5algK/Typ2JcQIyt7BtVm0PP9/2saKdplf53uBazNoxe/ku9tHbazokUwDqATK9FoL1yaSKYRqd21u0hZfH7OR+6+IG/AOE1DmAeAgE2UBcIlWS1BHPxFzatohXQbwgWqhXJtdy7Njetm82ZEV3Vwx8QBl7+LaTADufm0c777e6EhGv3ZxagNlZqimal+MNA9tgsv4YFzQFSQ8uhxSgsNjiiHSvJQtplrx62i/pS/lyKqm22s2Ly+8zLX5aHmXJGKXhXqOlVXFou6EyDCE9wVl7+HaQrR5nmXodItYkJUVo9HtuhNbbweCMqfWiLyDAJxGuzt9b/stM5ztkhu37U48WDV4Bih7L9cW0iV5b2jiHJ262zmilD12B6meu4RQGp2P3QWJ0Jc+u87zF5LZnW821+YVViVtI5Ja2aDLdb/ft93X7fbVdW3b7q871GT8P6VRrQcoCw6req5tJoC7ayGk6ktXSJ/BY5KSHgoRy7VWUBYG4KxMVBCAy21aArVyI9RrZ0O1l7g2K4BLVG0+aIlR+yoo+wjX9prWC369rn0AuE9HmlTu+3rtRyPNv+c/cIe0nzmlAAAAAElFTkSuQmCC",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Java / Springboot",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
    ],
  },
  {
    title: "Design",
    skills: [
      {
        name: "Figma",
        image:
          "https://cdn.simpleicons.org/figma",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://cdn.simpleicons.org/git/F05032",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Vercel",
        image:
          "https://cdn.simpleicons.org/vercel",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image: "https://cdn.simpleicons.org/postman"
      },
      
    ],
  },
];

export const experiences = [
   {
    id: 0,
    img: ahLogo,
    role: "Software Developer",
    company: "Automatic Heating Global",
    date: "Feb 2024 - Jan 2025",
    desc: " Developed a heat pump selection tool using TypeScript in Node.js, Express, and React to promote clean energy; reduced turnaround time by 47% and saved over $500K AUD by improving sales team and consultant efficiency. ",
    skills: [
      "TypeScript",
      "AWS",
      "React",
      "Node.js",
      "React",
      "CI/CD",
    ],
  },
  {
    id: 1,
    img: pwLogo,
    role: "Development Analyst",
    company: "Paperless Warehousing",
    date: "July 2022 - Feb 2024",
    desc: "Successfully implemented SOAP Services on 3 client servers, dramatically enhancing their integration capabilities and streamlining data exchange. Collaborated with senior developers to optimize and improve the codebase, resulting in streamlined operations and enhanced software performance. Redesigned and refined database systems, ensuring faster data retrieval and boosting system efficiency, directly contributing to superior user experiences. Collaborated with a team of 6 engineers to build backend components for a Warehouse Management System in Python, delivering features for 5+ enterprise clients (Clorox, Clifford Hallam, DHL, Harvey Norman, Diageo, Baby Bunting, Kraft Heinz). Implemented client-specific requirements such as new packing slip formats and EDI message modifications, ensuring compliance with company coding standards and reducing processing errors by 15%. Supported production environments by resolving 40+ support desk tickets/month, improving system stability and client satisfaction. ",
    skills: [
      "Docker",
      "AWS",
      "Python",
      "API",
      "SOAP",
      "Django",
    ],
  },
  
  {
    id: 2,
    img: shineSols,
    role: "Full Stack Developer",
    company: "Shine Solutions",
    date: "July 2023 - November 2023",
    desc: "Frontend Development: Spearheaded the creation of a user-centric frontend using ReactJS, which greatly enhanced team communication and provided real-time updates, resulting in seamless collaboration. Backend and AWS Integration: Developed the backend infrastructure using Java and harnessed the power of AWS services, particularly Lambda Services, to ensure robust and high-performance capabilities for the Retro AI+ platform.AI Task Assignment: Introduced advanced AI features that automatically assigned tasks based on team members' skills, availability, and workload. This innovative addition ensured a balanced distribution of tasks and facilitated timely project completion, improving overall efficiency.Agile Methodology: Embraced the SCRUM methodology for project management, promoting iterative development, regular feedback loops, and prompt adaptation to changes. This agile approach fostered a dynamic and productive team environment, enabling us to achieve our project goals effectively.",
    skills: [
      "ReactJS",
      "Java",
      "AWS",
      "AWS Lambda",
      "HTML",
      "CSS",
      "JavaScript",
      "TypeScript",
      "AWS DynamoDB",
      "ChatGPT API",
    ],
  },
  {
    id: 3,
    img: uniware,
    role: "Software Developer Intern",
    company: "Uniware",
    date: "Jan 2022 - July 2022",
    desc: "Spearheaded the design and development of a pivotal internal application using C# .NET, directly boosting operational efficiency, and facilitating smoother workflows for employees. Leveraged React JS expertise to create user-centric interfaces, greatly enriching user experience and facilitating ease of use for internal stakeholders. Successfully implemented over 50 RESTful and SOAP-based APIs, bridging gaps and ensuring flawless communication with external systems. Utilized Docker to deploy comprehensive websites, integrating SOAP and REST APIs to provide holistic solutions that empowered other employees. Additionally, employed Django to develop a web-based system for internal APIs, streamlining their management and enhancing accessibility, leading to significantly improved internal processes' efficiency. Seamlessly managed data operations with MariaDB, optimizing data storage and retrieval processes. Regularly conducted code reviews, pinpointing areas of enhancement, and subsequently refining software solutions, ensuring optimal performance and longevity of systems.",
    skills: [
      "ReactJS",
      "API",
      "C#",
      ".NET",
      "Figma",
      "MariaDB",
      "Django",
      "Python",
    ],
  },
];

export const education = [
  {
    id: 1,
    img: rmit,
    school: "RMIT University",
    date: "February 2020 - Dec 2023",
    grade: "3.5 / 4.0",
    degree: "Bachelor of Software Engineering",
  },
];

export const projects = [
  {
    id: 14,
    title: "MailLens.AI",
    date: "Aug 2025 - Sept 2025",
    description: " MailLens.AI syncs with your email account, processes messages incrementally, embeds and indexes them with Pinecone, and lets you search and chat with your emails using OpenAI models.",
    image: mail,
    tags: [
      "Python",
      "PostgreSQL",
      "Next.js",
      "Redis",
      "Pinecone",
      "Celery",
      "OpenAI API"
    ],
    category: "web app",
    github:"https://github.com/s3847243/MailLens",
    webapp: "https://mail-lens-gilt.vercel.app/",
  },
  {
    id: 13,
    title: "PersonalBrain.AI",
    date: "Aug 2025",
    description: " PersonalBrain.AI helps you upload documents (PDFs and more), securely store them, and transform them into a searchable, conversational knowledge hub. Files are chunked, embedded, and stored in Pinecone for semantic search, while GPT-3.5-turbo powers natural language chat with your knowledge.",
    image: brain,
    tags: [
      "Java",
      "Next.js",
      "PostgreSQL",      
      "AWS S3",
      "Render",
      "Pincone",
      "RabbitMQ"
    ],
    category: "web app",
    github:"https://github.com/s3847243/personal-brain-ai",
    webapp: "https://personal-brain-ai.vercel.app/",
  },
  {
    id: 12,
    title: "DevOpsLive",
    date: "July 2025 - Aug 2025",
    description:"DevOpsLive is a monitoring and productivity tool that integrates with GitHub and tracks commits, CI/CD builds, and issues, while also providing an API Watchdog to monitor REST endpoints and their performance.",
    image: devopslive,
    tags: [
      "React",
      "Django",
      "Python",
      "Celery",
      "Java",
      "IaC"
    ],
    category: "web app",
    github:"https://github.com/s3847243/devops-api-watchdog",
    webapp: "https://devops-api-watchdog.vercel.app/",
  },
  {
    id: 11,
    title: "Reel Resume",
    date: "April 2025",
    description:"ReelResume is a full-stack web application that enables job seekers to showcase their resume and pitch video through a personalized link. Built with a strong focus on backend performance, caching, and API security, ReelResume improves candidate visibility and helps increase recruiter engagement.",
    image: rr,
    tags: [
      "Java",
      "SpringBoot",
      "MongoDB",
      "Render",
      "Stripe",
      "Redis",
      "AWS S3"
    ],
    category: "web app",
    github:"https://github.com/s3847243/ReelResume",
    webapp: "https://reel-resume.vercel.app/",
  },
  {
    id: 10,
    title: "Jobpilot.ai+",
    date: "May 2025 - June 2025",
    description: "AI-powered job application assistant that helps you stand out in the hiring process.",
    image: job,
    tags: [
      "Java",
      "SpringBoot",
      "MongoDB",
      "RDS (PostgreSQL)",
      "AWS",
      "Terraform"
    ],
    category: "web app",
    github:"https://github.com/s3847243/jobpilotai",
    webapp: "https://jobpilotai-blush.vercel.app/",
  },
  {
    id: 9,
    title: "RetroAI+",
    date: "Jun 2023 - Nov 2023",
    description: "Retro AI+: An AI-enhanced project management tool designed to optimize task allocation and streamline team collaboration. Designed a user-centric frontend using ReactJS, facilitating seamless team communication and real-time updates, bolstered by backend structures in Java and AWS services (Lambda Services) for robust performance.Implemented AI features to automatically assign tasks based on team members' skills, availability, and workload, ensuring balanced distribution and timely project completion. Adopted the SCRUM methodology, ensuring iterative development, regular feedback,and prompt adaptation to changes, fostering a dynamic and productive team environment.",
    image: retroAI,
    tags: [
      "AWS",
      "AWS Lambda",
      "CI/CD",
      "React Js",
      "Java",
      "IaC"
    ],
    category: "web app",
    webapp: "http://retroaiplus-frontend-host.s3-website-ap-southeast-2.amazonaws.com/",
  }
  // ,
  // {
  //   id: 0,
  //   title: "Bookeroo",
  //   date: "2022",
  //   description:"A comprehensive full-stack library web application offering an intuitive interface using ReactJS, robust backend integration with Java's Spring Boot, and persistent storage using MySQL. Enhanced with RESTful APIs, the application showcases seamless deployment and testing capabilities, leveraging Docker, CircleCI, and AWS for optimum scalability and resilience.",
  //   image:
  //   bookeroo,
  //   tags: ["React Js", "Java", "SpringBoot", "Redux","MySQL"],
  //   category: "web app",
  //   github: "https://github.com/s3847243/Bookeroo",
  //   webapp: "https://github.com/s3847243/Bookeroo"
    
  // },
  ,
  {
    id: 1,
    title: "Qwirkle Game",
    date: "2022",
    description:"Developed a Qwirkle game implementation in C++, showcasing strong programming skills and creativity. Implemented the rules and mechanics of the popular board game, including tile placement, scoring, and strategic gameplay. Utilized object-oriented programming principles to design modular and maintainable code. Leveraged data structures and algorithms to efficiently manage the game state and enable smooth gameplay",
    image: qwirkle,
    tags: [
      "C++"
    ],
    category: "Desktop",
    github: "https://github.com/s3847243/qwirkle",
    webapp: "https://github.com/s3847243/qwirkle"

  },
  // {
  //   id: 2,
  //   title: "Chatbot AI",
  //   date: "2023",
  //   description:"Chatbot AI in Python is an innovative and user-friendly project designed to revolutionize the way humans interact with machines. This project leverages the power of artificial intelligence to create a dynamic and conversational chatbot. It serves as a virtual assistant capable of engaging in meaningful and context-aware conversations with users.",
  //   image: chatbot,
  //   tags: ["Python"],
  //   category: "web app",
  //   github: "https://github.com/s3847243/chatbot-AI",
  //   webapp: "https://github.com/s3847243/chatbot-AI",

    
  // },
  // {
  //   id: 3,
  //   title: "Social Media App",
  //   date: "2023",
  //   description:"A vibrant social web platform built upon the powerful MERN stack, encapsulating dynamic, responsive user interfaces with React.js. It harmoniously integrates a solid backend foundation with Express.js and Node.js, ensuring real-time data interactions using MongoDB for a fluid user-centric browsing experience.",
  //   image: socialMedia,
  //   tags: ["HTML", "JavaScript", "TypeScript", "CSS","Redux","NextJS"],
  //   category: "web app",
  //   github: "https://github.com/s3847243/reddit-app",
  //   webapp: "https://github.com/s3847243/reddit-app",
  // },
  // {
  //   id: 10,
  //   title: "Messenger",
  //   date: "Jun 2022",
  //   description:
  //     "Facebook Messenger Clone using ReactJS and Firebase",
  //   image: mesclone,
  //   tags: ["ReactJS", "JavaScript", "Firebase"],
  //   category: "web app",
  //   github: "https://github.com/s3847243/facebook-messenger-clone",
  //   webapp: "https://github.com/s3847243/facebook-messenger-clone",

  // },
  
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
